<template>
  <div class="pt-227 pb-100">
    <div class="container">
      <div class="career-details-content bg-white">
        <div
          class="d-md-flex justify-content-between align-items-center career-info"
        >
          <h3>Online Marketing Manager</h3>
          <ul class="ps-0 mb-0 list-unstyled d-sm-flex mt-3 mt-md-0">
            <li class="d-flex align-items-center mb-3 mb-sm-0">
              <div class="icon">
                <img src="../../assets/images/location.png" alt="location" />
              </div>
              <span class="ms-2">Texas</span>
            </li>
            <li class="d-flex align-items-center mb-3 mb-sm-0">
              <div class="icon">
                <img src="../../assets/images/bag.png" alt="bag" />
              </div>
              <span class="ms-2">Full Time</span>
            </li>
            <li class="d-flex align-items-center">
              <div class="icon">
                <img src="../../assets/images/calendar.png" alt="calendar" />
              </div>
              <span class="ms-2">July 29, 2024</span>
            </li>
          </ul>
        </div>

        <h4>Job Details:</h4>
        <p>
          Welcome to "Demystifying Paid Search Ads: A Beginner's Guide." If
          you've ever wondered how businesses appear at the top of search engine
          results, you're about to discover the secret behind their success.
          Paid search advertising, also known as Pay-Per-Click (PPC), is a
          powerful digital marketing tool that allows businesses to bid on
          keywords and display targeted ads to potential customers. In this
          comprehensive guide, we'll break down the fundamentals of paid search
          ads, empowering you to harness this effective strategy and propel your
          business to new heights in the digital landscape.
        </p>

        <div class="mb-lg-5 mb-4"></div>

        <h4>Open Number of Position:</h4>
        <p>05</p>

        <div class="mb-lg-5 mb-4"></div>

        <h4>Responsibilities</h4>
        <p class="mb-4">
          You will be responsible for managing all SEO activities such as
          content strategy, link building, and keyword strategy to increase
          rankings on all major search networks. You will also manage all SEM
          campaigns on Google, Yahoo, and Bing to maximize ROI.
        </p>
        <ul class="ps-0 mb-4 list-unstyled responsibilities">
          <li>
            – Work with and support other Search Engineers, Internet Marketers,
            Designers, Programmers, Art and Creative Directors on high-end
            websites.
          </li>
          <li>
            – Develop your skills and augment your training with directed
            research in your very specific tasks.
          </li>
          <li>
            – Use the online productivity platform Asana to organize and keep
            track of your completed tasks.
          </li>
          <li>
            – Get constant feedback and suggestions on how to improve your
            skills.
          </li>
          <li>
            – Break through barriers and confusion by working with the team
            before you are frustrated with tasks.
          </li>
          <li>
            – Be certain you are studying and practicing the most important
            daily skills you need to be an elite level internet marketer and
            search engine optimizer
          </li>
          <li>
            – Coordinates with individual brand managers to maintain website
            content in a timely manner.
          </li>
          <li>
            – Configures websites to deliver functionality and promotions as
            directed.
          </li>
          <li>
            – Generates and analyzes SEO reports, monitors opportunities for
            improvement, and implements SEO changes to the websites
          </li>
          <li>
            – Audits website content for reliability, accuracy, and usability.
            Updates website metadata and content daily to ensure relevance and
            accuracy.
          </li>
        </ul>
        <p>
          Other Skills: Google Analytics, Internet Marketing, Link Building,
          Off-page Optimization, On-Page Optimization, Search Engine
          Optimization (SEO), SEO Audit, SEO Backlinking, SEO Keyword Research,
          Social Media Marketing
        </p>

        <div class="mb-lg-5 mb-4"></div>

        <h4>Ideal Qualifications:</h4>
        <ul class="ps-0 mb-0 list-unstyled ideal">
          <li>
            Bachelor's degree in marketing, communications, public relations, or
            a related field is preferred.
          </li>
          <li>
            Ideally 4 years of experience in social media management, preferably
            in the nutrition, health, or wellness industry. Provide a portfolio
            or examples of successful social media campaigns.
          </li>
          <li>
            Strong understanding of various social media platforms, their
            features, algorithms, and best practices. Proficiency in using
            social media management and analytics tools.
          </li>
          <li>
            Excellent copywriting skills with the ability to create engaging and
            compelling content. Proficiency in graphic design and video editing
            software is not a requirement but is a plus.
          </li>
          <li>
            Experience in identifying, collaborating with, and managing
            influencers for successful marketing campaigns. Familiarity with
            influencer marketing platforms and tools.
          </li>
          <li>
            Ability to develop and execute social media strategies aligned with
            business goals. Strong analytical skills to track metrics, analyze
            data, and make data-driven decisions.
          </li>
          <li>
            Proven track record of creating innovative social media campaigns
            and content ideas. Ability to think outside the box and stay updated
            with the latest trends.
          </li>
          <li>
            Excellent communication and interpersonal skills to effectively
            collaborate with internal teams, external partners, and influencers.
          </li>
          <li>
            Strong work ethic and a desire to continuously learn and improve
          </li>
          <li>
            A scrappy, startup mindset, with no fear of taking ownership to
            develop and drive your vision
          </li>
          <li>The desire to win, with an inherently competitive spirit</li>
          <li>
            You live, breathe, eat, sleep, and dream social media; if talking
            about the TikTok algorithm doesn't excite you, this role may not be
            a good fit!
          </li>
        </ul>

        <div class="mb-lg-5 mb-4"></div>

        <router-link to="/contact-us" class="default-btn">
          APPLY NOW
          <img
            src="../../assets/images/icon-right-white.png"
            alt="icon-right-white"
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CareerDetails",
};
</script>

<style lang="scss" scoped>
.career-details-content {
  padding: 55px 65px;
  border: 1px solid #e3e3e3;
  border-radius: 20px;
  .career-info {
    margin-bottom: 45px;
    h3 {
      margin-bottom: 0;
      font-size: 24px;
    }
    ul {
      li {
        margin-right: 25px;

        .icon {
          width: 32px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          border-radius: 50px;
          background-color: #e3e3e3;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  h4 {
    font-family: var(--bodyFontFamily);
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 9px;
  }
  .responsibilities {
    li {
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .ideal {
    li {
      margin-bottom: 10px;
      position: relative;
      padding-left: 20px;

      &::before {
        content: "";
        position: absolute;
        top: 9px;
        left: 0;
        width: 5px;
        height: 5px;
        background-color: var(--bodyColor);
        border-radius: 50px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .career-details-content {
    padding: 20px;

    h3 {
      font-size: 22px;
    }
    .career-info {
      margin-bottom: 30px;
    }
  }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .career-details-content {
    padding: 20px;

    h3 {
      font-size: 20px;
    }
    .career-info {
      margin-bottom: 30px;
    }
    .career-info {
      ul {
        li {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>